const Canvas = ()=>{
    return(
        <div className="vh-100 banner2"></div>
    )
}

export default Canvas